import { useMutation } from "@tanstack/react-query";
import { API_URL } from "../../../../services/constant";

const useEnsureStaxCustomer = () => {

    const mutation = useMutation({
        mutationFn: async () => {
            let accessToken = JSON.parse(localStorage.getItem('accessToken'));
            const response = await fetch(
                `${API_URL}/payments/customer/ensure/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${accessToken}`
                    },
                    
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data?.message ||
                    "Failed to initialize Stax customer"
                );
            }

            if (!data?.customer_id) {
                throw new Error(
                    "Stax customer ID was not returned."
                );
            }

            return data;
        },
    });

    return {
        ensureStaxCustomer: mutation.mutate,
        ensureStaxCustomerAsync: mutation.mutateAsync,

        isEnsuringCustomer: mutation.isPending,
        isCustomerReady: mutation.isSuccess,
        isCustomerError: mutation.isError,
        customerError: mutation.error,

        customerResponse: mutation.data,

        staxCustomerId:
            mutation.data?.customer_id || null,
    };
};

export default useEnsureStaxCustomer;